import { Link } from 'react-router-dom';
import { allTags } from '@/utils/news';

const sizeByHeat = (heat: number) => {
  if (heat >= 900000) return 'text-base';
  if (heat >= 700000) return 'text-sm';
  return 'text-xs';
};

export default function TagCloud() {
  const maxHeat = Math.max(...allTags.map((tag) => tag.heat));

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
        <i className="ri-price-tag-3-fill text-accent-500"></i>
        热门趋势标签
      </h2>
      <div className="flex flex-wrap gap-2">
        {allTags.map((tag, index) => {
          const hot = tag.heat === maxHeat || index < 3;
          return (
            <Link
              key={tag.name}
              to={`/search?q=${encodeURIComponent(tag.name)}`}
              className={`${sizeByHeat(tag.heat)} rounded-full px-3 py-1.5 font-medium transition-colors ${
                hot
                  ? 'bg-accent-100 text-accent-900 hover:bg-accent-500 hover:text-background-50'
                  : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-500 hover:text-background-50'
              }`}
            >
              #{tag.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
}